import dispatcher from '@mailobj-browser/front/js/utils/dispatcher.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'

import { execute } from '../../common/intents/intent.js'
import { load } from '../../common/pages/divlocal.js'

const typePage = 'page'
const typeShare = 'share'
const typeStatus = 'status'

const appDispatcher = object(dispatcher)
const subscription = appDispatcher.subscribe()
queueMicrotask(async () => {
  for await (const obj of subscription) {
    if (!obj)
      continue
    const { type, data } = obj
    if (!type) {
      console.error('appDispatcher: type is mandatory')
      continue
    }
    console.log(obj)
    if (type === typePage) {
      await load(data)
    } else if (type === typeShare) {
      await execute(data)
    } else if (type === typeStatus) {

    }
  }
})

export default () => {
}

export const publish = (obj) => {
  appDispatcher.dispatch(obj)
}

export const publishPage = (data) => {
  publish({ type: typePage, data })
}

export const publishShare = (data) => {
  publish({ type: typeShare, data })
}

export const publishStatus = (data) => {
  publish({ type: typeStatus, data })
}

/* used by legacy code (local.js) : */
globals.ea_local_publish_page = publishPage
globals.ea_local_publish_share = publishShare
globals.ea_local_publish_status = publishStatus
